import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './common.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'mobx-react'
import stores from './Stores'
import { initializeFirebase } from './Utils/pushNotification'
import * as Sentry from '@sentry/react'
import { Integrations as ApmIntegrations } from '@sentry/apm'
import {
  SENTRY_DSN,
  SENTRY_PROJECT_NAME,
  SENTRY_VERSION,
  SENTRY_TRACE_SAMPLE_RATE,
  SENTRY_ENV,
} from './Utils/constants'

Sentry.init({
  dsn: SENTRY_DSN,
  release: `${SENTRY_PROJECT_NAME}-${SENTRY_VERSION}`,
  integrations: [new ApmIntegrations.Tracing()],
  tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,
  environment: SENTRY_ENV,
})

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={'An error has occured'}>
    <Provider {...stores}>
      <App />
    </Provider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
)

initializeFirebase()
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
